<script setup>

import { computed, ref, onMounted, watch } from "vue";
import ERP from "../../api/v2/ERP.mjs";
import View from "../../api/v2/View.mjs";
import UtilArray from "../../utils/UtilArray.mjs";
import UtilResponse from "../../utils/UtilResponse.js";
import useColaboradorStore from "../../api/v2/stores/ColaboradorStore.js";
import UtilObject from "@/utils/UtilObject.js";
import OrdemDeServicoLiberarItensService from "@/api/v2/services/OrdemDeServicoLiberarItensService.js";
import UtilMoney from "@/utils/UtilMoney.js";

//==================================================================//
//======================== Colaborador Store =======================//
//==================================================================//

const colaboradorStore = useColaboradorStore();

//==================================================================//
//======================= Dados Originais ==========================//
//==================================================================//

const dadosOriginais = ref([]);
const dadosOriginaisLoading = ref(true);

//==================================================================//
//============================== Dados =============================//
//==================================================================//

const dados = ref([]);

//==================================================================//
//======================= Select Filter Job ========================//
//==================================================================//

const selectFilterJobs = ref([]);
const selectedFilterJob = ref("");

//==================================================================//
//=========================== Filtros OS ===========================//
//==================================================================//

const selectFilterOrdensDeServico = ref([]);
const selectedFilterOrdemDeServico = ref("");

//==================================================================//
//========================= Filtros Status =========================//
//==================================================================//

const selectFilterStatus = ref([]);
const selectedFilterStatus = ref("");

//==================================================================//
//======================= Liberando Itens Loading ==================//
//==================================================================//

const liberandoItensLoading = ref(false);

//==================================================================//
//======================== Controles Desativados ===================//
//==================================================================//

const controlesDesativados = ref(false);

//==================================================================//
//=========================== Tabela de Dados ======================//
//==================================================================//

const dabelaDeDadosKey = ref(0);

//==================================================================//
//========================== Dados Filtrados =======================//
//==================================================================//

const dadosFiltrados = computed(() => {

    return dadosOriginais.value.map((job)=>{

        let ordensDeServico = job.ordensDeServico.map((ordemDeServico)=>{

            let itens = ordemDeServico.itens.map((item)=>{

                return{
                    id: item.id || "",
                    sequencia: item.sequencia || "",
                    status: item.status || "",
                }

            });

            return{
                id: ordemDeServico.id || "",
                codigo: ordemDeServico.codigo || "",
                itens: itens || [],
            }

        });

        return{
            id: job.id || "",
            codigo: job.codigo || "",
            ordensDeServico: ordensDeServico || []
        }

    });

});

//==================================================================//
//======================= Dados Selecionados =======================//
//==================================================================//

const dadosSelecionados = computed(() => {

    return dados.value.filter(({selecionado})=> selecionado == true);

});

//==================================================================//
//=========================== Dados Validos ========================//
//==================================================================//

const dadosValidos = computed(() => {

    if(UtilArray.isEmpty(dadosSelecionados.value)){
        return false;
    }

    return dadosSelecionados.value.every((dado) => {

        if(dado.statusAtual == dado.statusNovo){
            return false;
        }

        return true;

    });

});

//==================================================================//
//======================== Desativa Liberar Itens ==================//
//==================================================================//

const desativaLiberarItens = computed(() => {

    if(controlesDesativados.value == true){
        return true;
    }

    if(dadosValidos.value == false){
        return true;
    }

    return false;

});

//==================================================================//
//=============== Dados Selecionados Status Helper =================//
//==================================================================//

const dadosSelecionadosStatusHelper = computed(() => {

    let possiveisStatus = ["ED","LC", "SC", "LA", "CN"];

    if(UtilArray.isEmpty(dadosSelecionados.value)){
        return [];
    }

    for (let dadoSelecionado of dadosSelecionados.value){

        if(dadoSelecionado.statusAtual === "ED"){

            possiveisStatus = UtilArray.removeList(possiveisStatus, ["ED","SC","LA"]);

        }
        
        if(dadoSelecionado.statusAtual === "LC" && dadoSelecionado?.item?.tipo === "MD"){

            possiveisStatus = UtilArray.removeList(possiveisStatus, ["LC","LA"]);

        }

        if(dadoSelecionado.statusAtual === "LC" && dadoSelecionado?.item?.tipo !== "MD"){

            possiveisStatus = UtilArray.removeList(possiveisStatus, ["LC"]);

        }

    }

    return possiveisStatus;

});

//==================================================================//
//====================== Set Controles Desativados =================//
//==================================================================//

const setControlesDesativados = (update = false) => {

    controlesDesativados.value = update;

};

//==================================================================//
//========================= Set Dados Originais ====================//
//==================================================================//

const setDadosOriginais = (update = []) => {

    dadosOriginais.value = update;
    resetTabelaDeDados();
    clearAllFilters();

};

//==================================================================//
//===================== Set Dados Originais Loading ================//
//==================================================================//

const setDadosOriginaisLoading = (update = false) => {

    dadosOriginaisLoading.value = update;

};

//==================================================================//
//============================= Set Dados ==========================//
//==================================================================//

const setDados = (update = []) => {

    dados.value = update;

};

//==================================================================//
//===================== Set Liberando Itens Loading ================//
//==================================================================//

const setLiberandoItensLoading = (update = false) => {

    liberandoItensLoading.value = update;

};

//==================================================================//
//======================= Reset Tabela de Dados ====================//
//==================================================================//

const resetTabelaDeDados = () => {

    dabelaDeDadosKey.value += 1;

};

//==================================================================//
//========================= Update Dados ===========================//
//==================================================================//

const updateDados = (updates = []) => {

    let dadosAlterados = dados.value.map((dado) => {

        let update = updates.find((update)=> update.id == dado.id);

        if(dado?.id !== update?.id){
            return dado;
        }

        return UtilObject.merge(dado,update);
        
    });

    setDados(dadosAlterados);

};

//==================================================================//
//========================= Update Dado ============================//
//==================================================================//

const updateDado = (update = {}) => {

    let dadosAlterados = dados.value.map((dado) => {

        if(dado?.id !== update?.id){
            return dado;
        }

        return UtilObject.merge(dado,update);
        
    });

    setDados(dadosAlterados);

};

//==================================================================//
//===================== Ao Setar Dados Status ======================//
//==================================================================//

const onSetDadosStatus = (update) => {

    let dadosAlterar = dadosSelecionados.value.map((dadoSelecionado)=>{

        return{
            id: dadoSelecionado.id,
            statusNovo: update.statusNovo
        };

    });

    updateDados(dadosAlterar);

};


//==================================================================//
//==================== Ao Setar Dados Selecionados =================//
//==================================================================//

const onSetDadosSelecionado = (update = {}) => {

    let updates = update.itens.map((item)=>{

        return{
            id: item.id,
            selecionado: update.selecionado
        }

    });

    updateDados(updates);

};

//==================================================================//
//====================== Ao Setar Dado Status ======================//
//==================================================================//

const onSetDadoStatus = (update) => {

    updateDado({
        id: update.id,
        statusNovo: update.statusNovo,
    });

};

//==================================================================//
//================== Ao Setar Dado Selecionado =====================//
//==================================================================//

const onSetDadoSelecionado = (update = {}) => {

    updateDado({
        id: update.item.id,
        selecionado: update.selecionado,
    });

};

//==================================================================//
//====================== Limpa Todos os Filtros ====================//
//==================================================================//
const clearAllFilters = () => {

    selectFilterJobs.value = [];
    selectFilterOrdensDeServico.value = [];
    selectFilterStatus.value = [];

    selectedFilterJob.value = "";
    selectedFilterOrdemDeServico.value = "";
    selectedFilterStatus.value = "";

};

//==================================================================//
//======================= Header Filter Job ========================//
//==================================================================//

const headerFilterJob = (jobCodigo) => {

    if(!selectedFilterJob.value){
        return true;
    }

    const jobCodigoFormatado = jobCodigo?.toLowerCase();
    const jobSelecionadoFormatado = selectedFilterJob.value?.toLowerCase();

    return jobCodigoFormatado?.includes(jobSelecionadoFormatado) ?? false;

};

//==================================================================//
//============================ Filter OS ===========================//
//==================================================================//

const headerFilterOrdemDeServico = (osCodigo) => {

    if(!selectedFilterOrdemDeServico.value){

        return true;

    }

    const osCodigoFormatado = osCodigo?.toLowerCase();
    const osSelecionadoFormatado = selectedFilterOrdemDeServico.value?.toLowerCase();

    return osCodigoFormatado?.includes(osSelecionadoFormatado) ?? false;

};

//==================================================================//
//========================== Filter Status =========================//
//==================================================================//

const headerFilterStatus = (statusNovo) => {

    if(!selectedFilterStatus.value){

        return true;

    }

    const statusNovoFormatado = statusNovo?.toLowerCase();
    const statusSelecionadoFormatado = selectedFilterStatus.value?.toLowerCase();

    return statusNovoFormatado?.includes(statusSelecionadoFormatado) ?? false;

};

//==================================================================//
//==================== Headers Ordem de Servico ====================//
//==================================================================//

const ordemDeServicoItensHeaders = [
    { text: 'Job',                    value: 'job.codigo',                                 class:"c-table__header",    cellClass:'c-table__item',    filter: headerFilterJob},
    { text: 'OS',                     value: 'ordemDeServico.codigo',                      class:"c-table__header",    cellClass:'c-table__item',    filter: headerFilterOrdemDeServico},
    { text: 'Sequência',              value: 'sequencia',                                  class:"c-table__header",    cellClass:'c-table__item',    filterable: false,},
    { text: 'Status',                 value: 'statusAtual',                                class:"c-table__header",    cellClass:'c-table__item',    filter: headerFilterStatus},
    { text: 'Código do Item',         value: 'item.codigo',                                class:"c-table__header",    cellClass:'c-table__item',    filterable: false,},
    { text: 'Descrição',              value: 'item.descricao',                             class:"c-table__header",    cellClass:'c-table__item',    width:"550"},
    { text: 'Quantidade',             value: 'quantidade',                                 class:"c-table__header",    cellClass:'c-table__item',    filterable: false,},
    { text: 'Unidade',                value: 'unidade.sigla',                              class:"c-table__header",    cellClass:'c-table__item',    filterable: false,},
    { text: 'Valor Disponivel',       value: 'valorDisponivel',                            class:"c-table__header",    cellClass:'c-table__item',    filterable: false,  width:"150", },
    { text: 'Data de Solicitação',    value: 'ordemDeServico.dataSolicitacaoFormatada',    class:"c-table__header",    cellClass:'c-table__item',    },
    { text: 'Data de Necessidade',    value: 'dataNecessidadeFormatada',                   class:"c-table__header",    cellClass:'c-table__item',    },
];

//==================================================================//
//================ Get Dado Opcoes Status Novo =====================//
//==================================================================//

const getDadoOpcoesStatusNovo = (dado = {}) => {

    let opcoes = [];

    if(dado.statusAtual === "ED"){
        opcoes = ["ED", "LC", "CN"];
    }

    if(dado.statusAtual === "LC" && dado?.item?.tipo === "MD"){
        opcoes = ["LC", "ED", "SC", "CN"];
    }

    if(dado.statusAtual === "LC" && dado?.item?.tipo !== "MD"){
        opcoes = ["LC", "ED", "LA", "SC", "CN"];
    }

    opcoes = opcoes.map((opcaoStatus)=>{

        return {
            text: opcaoStatus,
            value: opcaoStatus,
            disabled: opcaoStatus === dado?.statusAtual,
        };

    });
       
    return opcoes;

};

//==================================================================//
//=========================== Processa Dados =======================//
//==================================================================//

const processaDados = (dadosOriginais = []) => {

    let accJobs = [];
    let accOrdensDeServico = [];
    let accStatus = [];

    const dadosProcessados = dadosOriginais.flatMap((job) => {

        accJobs.push(job.codigo);

        return job.ordensDeServico.flatMap((ordemDeServico) => {

            accOrdensDeServico.push(ordemDeServico.codigo);

            return ordemDeServico.itens.flatMap((item) => {

                accStatus.push(item.status);

                const dadoProcessado = {
                    selecionado: false,
                    id: item?.id || "",
                    job: {
                        id: job?.id || "",
                        codigo: job?.codigo || "",
                    },
                    ordemDeServico: {
                        id: ordemDeServico?.id || "",
                        codigo: ordemDeServico?.codigo || "",
                        dataSolicitacaoFormatada: ordemDeServico?.dataSolicitacaoFormatada || "",
                    },
                    statusAtual: item?.status || "",
                    statusNovo: item?.status || "",
                    sequencia: item?.sequencia || "",
                    quantidade: item?.quantidade || 0,
                    descricao: item?.descricao || "",
                    dataNecessidade: item?.dataNecessidade || "",
                    dataNecessidadeFormatada: item?.dataNecessidadeFormatada || "",
                    valorDisponivel: item?.valorDisponivel || 0,
                    item: item?.item || {},
                    unidade: item?.unidade || {},
                };

                return dadoProcessado;

            });

        });

    });

    selectFilterJobs.value = UtilArray.unique(accJobs);
    selectFilterOrdensDeServico.value = UtilArray.unique(accOrdensDeServico);
    selectFilterStatus.value = UtilArray.unique(accStatus);

    setDados(dadosProcessados);

};

//==================================================================//
//============================== Load Dados =========================//
//==================================================================//

const loadDados = async () => {

    setDadosOriginaisLoading(true);
    setControlesDesativados(true);

    const dadosResponse = await ERP.getManyWithView(View.ORDEM_DE_SERVICO_LIBERAR_ITENS);

    setDadosOriginais(dadosResponse?.data);
    processaDados(UtilArray.clone(dadosResponse?.data));

    setControlesDesativados(false);
    setDadosOriginaisLoading(false);

};

//==================================================================//
//========================== Ao Liberar Itens ======================//
//==================================================================//

const aoLiberarItens = async () => {

    setControlesDesativados(true);
    setLiberandoItensLoading(true);

    let ordemDeServicoItensValores = dadosSelecionados.value.map((dadoSelecionado)=>{
        return{
            id: dadoSelecionado.id,
            status: dadoSelecionado.statusNovo
        };
    });

    const ordemDeServicoItens = await OrdemDeServicoLiberarItensService.liberarItens(ordemDeServicoItensValores);
    if(UtilResponse.isNotOk(ordemDeServicoItens)){
        throw new Error("Falha ao liberar os Itens das Ordens de Serviço");
    }

    await loadDados();

    setLiberandoItensLoading(false);
    setControlesDesativados(false);

};

//==================================================================//
//============================= On Mounted =========================//
//==================================================================//

onMounted(async () => {

    await loadDados();

});

</script>

<template>

    <main class="c-main" :class="{ 'c-main--disabled': controlesDesativados }">

        <h2>Liberar Itens</h2>

        <v-card class="c-card">

            <v-card-title class="c-table-holder">

                <div class="c-table">

                    <h3 class="c-table__titulo">Itens das Ordens de Serviço</h3>

                    <div class="c-busca">

                        <v-select
                            label="Job"
                            class="c-busca__job"
                            v-model="selectedFilterJob"
                            :items="selectFilterJobs"
                            :item-props="true"
                            item-text="codigo"
                            hide-details
                            outlined
                            clearable
                            :disabled="controlesDesativados"
                        ></v-select>

                        <v-select
                            label="OS"
                            class="c-busca__os"
                            v-model="selectedFilterOrdemDeServico"
                            :items="selectFilterOrdensDeServico"
                            :item-props="true"
                            item-text="codigo"
                            hide-details
                            outlined
                            clearable
                            :disabled="controlesDesativados"
                        ></v-select>

                        <v-select
                            label="Status"
                            class="c-busca__status"
                            v-model="selectedFilterStatus"
                            :items="selectFilterStatus"
                            :item-props="true"
                            hide-details
                            outlined
                            clearable
                            :disabled="controlesDesativados"
                        ></v-select>

                    </div>

                     <div class="c-botoes-status-helper">

                            <v-btn v-for="status in dadosSelecionadosStatusHelper"
                                :key="status"
                                class="c-botao-status-helper"
                                color="primary"
                                elevation="2"
                                @click="onSetDadosStatus({statusNovo:status})"
                                :disabled="controlesDesativados"
                            >
                            
                                {{status}}
                                
                            </v-btn>

                     </div>

                    <div class="c-controles">

                        <v-chip class="c-usuario" label>

                            <v-icon left>mdi-account-circle-outline</v-icon>
                            Usuario: {{colaboradorStore?.colaborador?.nome}}

                        </v-chip>

                        <div class="c-controles__botao-direita">

                            <v-tooltip bottom>

                                <template v-slot:activator="{ on, attrs }">

                                    <v-btn
                                        color="primary"
                                        elevation="2"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="aoLiberarItens"
                                        :disabled="desativaLiberarItens"
                                        :loading="liberandoItensLoading"
                                    >
                                    
                                        Liberar Itens
                                        
                                    </v-btn>

                                </template>

                                <span>Liberar itens selecionados</span>

                            </v-tooltip>

                        </div>

                    </div>

                </div>

            </v-card-title>

            <v-data-table
                :key="dabelaDeDadosKey"
                class="c-table__data elevation-1"
                :headers="ordemDeServicoItensHeaders"
                :items="dados"
                :items-per-page="-1"
                select-strategy="all"
                item-key="id"
                show-select
                return-object
                @item-selected="onSetDadoSelecionado({item:$event?.item,selecionado:$event.value})"
                @toggle-select-all="onSetDadosSelecionado({itens:$event?.items,selecionado:$event.value})"
                :loading="dadosOriginaisLoading"
                loading-text="Carregando... Por favor, aguarde."
            >

                <template v-slot:item.descricao="{ item }">

                    <p class="c-cell__descricao">{{item.descricao}}</p>

                </template>

                <template v-slot:item.statusAtual="{ item }">

                    <v-select
                        class="c-cell__status-novo"
                        :value="item.statusNovo"
                        :lazyValue="item.statusNovo"
                        :items="getDadoOpcoesStatusNovo(item)"
                        item-text="text"
                        item-value="value"
                        item-disabled="disabled"
                        hide-details
                        outlined
                        dense
                        :disabled="controlesDesativados"
                        @input="onSetDadoStatus({ id:item.id, statusNovo: $event})"
                    ></v-select>

                </template>

                <template v-slot:item.valorDisponivel="{ item }">

                    {{ UtilMoney.toR$BRL(item.valorDisponivel) }}
                
                </template>
        
            </v-data-table>

        </v-card>

    </main>

</template>

<style scoped>

/*==================================================================*/
/*============================= Main ===============================*/
/*==================================================================*/

.c-main{
    display: grid;
    gap: 15px;
}

.c-main--disabled{
    pointer-events: none;
    user-select: none; 
}

.c-main--disabled :deep(.c-table__header) {
    pointer-events: none;
    user-select: none;
}

/*==================================================================*/
/*============================= Card ===============================*/
/*==================================================================*/

.c-card{
    display: grid;
}

/*==================================================================*/
/*========================= Table Holder ===========================*/
/*==================================================================*/

.c-table-holder{
    display: grid;
}

.c-table{
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: auto auto auto; 
    grid-template-areas: 
    "titulo titulo"
    "buscas controles"
    "botoesStatusHelper controles";
    gap: 10px;
    align-items: initial;
}

.c-table__titulo { 
    grid-area: titulo;
}

/*==================================================================*/
/*============================= Buscas =============================*/
/*==================================================================*/

.c-busca { 
    grid-area: buscas;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr; 
    gap: 10px;
    grid-template-areas: 
        "buscaJob buscaOS buscaStatus";
}

.c-busca__job{
    grid-area: buscaJob;
}

.c-busca__os{
    grid-area: buscaOS;
}

.c-busca__status{
    grid-area: buscaStatus;
}

/*==================================================================*/
/*============================= Buscas =============================*/
/*==================================================================*/

.c-botoes-status-helper { 
    grid-area: botoesStatusHelper;
    display: flex;
    gap: 10px;
}

.c-botao-status-helper{
    width: 30px;
}

/*==================================================================*/
/*============================ Controles ===========================*/
/*==================================================================*/

.c-controles { 
    grid-area: controles;
    display: grid;
    grid-template-rows: auto auto;
    grid-template-areas: 
    "usuario"
    "botao-direita";
    align-items: center;
    gap: 10px;
}

.c-controles__botao-direita { 
    grid-area: botao-direita;
    display: grid;
    grid-auto-flow: column;
}

/*==================================================================*/
/*============================ Usuario =============================*/
/*==================================================================*/

.c-usuario{
    grid-area: usuario;
    min-height: 48px;
}

.c-usuario :deep(.v-chip__content){
    margin: auto;
}

/*==================================================================*/
/*============================== Tabela ============================*/
/*==================================================================*/

.c-table__data{
    display: grid;
    white-space: nowrap;
}

.c-cell__descricao{
    white-space: normal;
    margin: 0px !important;
}

.c-cell__status-novo{
    white-space: normal;
    margin: 0px !important;
}

.c-cell__status-novo :deep(.v-select__selection--disabled){
    opacity: 1 !important;
    color: inherit !important;
}

.c-cell__valor-disponivel{
    white-space: normal;
    margin: 0px !important;
}

</style>